import styled, { css, ThemeContext, props } from 'styled-components';
import { useContext } from 'react';
import { rem } from 'polished';

// TODO: move styles into Component
export const Banner = styled.div`
  ${({ theme }) => {
    // const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      display: flex;
      max-width: ${rem('2000px')};
      min-height: ${rem('50px')};
      margin: 0 auto;
      align-items: center;
      box-shadow: ${theme.shadows.inner};
    `
  }}
`;

export const DismissButton = styled.button`
  ${({ theme }) => {
    const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      position: ${mediumDown ? 'absolute' : 'relative'};
      right: ${mediumDown ? rem('30px') : rem('24px')};
      top: ${mediumDown ? 0 : 'unset'};
      width: ${mediumDown ? rem('14px') : rem('18px')};
      height: ${mediumDown ? rem('14px') : rem('18px')};
      margin-top: ${mediumDown ? rem('28px') : 0};
      padding: 0;
      border: 0;
      background: rgba(255, 255, 255, 0.2); /* TODO: use highlight color function */
      cursor: pointer;
      ::before, ::after {
        content: '';
        width: ${rem('2px')};
        height: 100%;
        background-color: ${theme.colors.neutral.grey29};
        transform: rotate(45deg) translateX(0);
        position: absolute;
        left: 50%;
        top: 0;
      }
      ::before {
        transform: rotate(-45deg) translateX(0);
      }
      :hover::before, :hover::after {
        background-color: ${theme.colors.neutral.grey54};
      }
    `
  }}
`

export const DataSeparator = styled.span`
  margin: 0 ${rem('12px')};
`

export const DataTextContainer = styled.p`
  ${({ theme, variant }) => {
    const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      && {
        display: inline-block;
        width: ${variant ? '100%' : 'auto'};
        font-weight: 300;
        font-size: ${mediumDown ? rem('14px') : rem('16px')};
        line-height: ${mediumDown ? rem('21px') : rem('24px')};
        color: ${variant === 'drawer-contents' ? theme.colors.neutral.grey29 : theme.colors.primary.blue};
        text-align: ${mediumDown
          && (variant !== 'drawer') ? 'left' : 'center'
          && (variant === 'drawer-contents') ? 'left' : 'center'
        };
      }
    `
  }}
`

export const StartAdornment = styled.span`
  ${({ theme, variant }) => {
    const smallDown = theme.useMediaQuery(theme.breakpoints.down('small'));
    const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      position: ${mediumDown && variant !== 'drawer' ? 'absolute' : 'relative'};
      left: 0;
      margin-right: ${!mediumDown && variant !== 'drawer' ? rem('20px') : 0};
      margin-left: ${mediumDown ? rem('16px') : 0};
      display: inline-block;
    `
  }}
`

// TODO: should be the same as DataTextContainer, so look to combine
export const DrawerContents = styled.p`
  ${({ theme }) => {
    const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      && {
        display: inline-block;
        width: ${variant ? '100%' : 'auto'};
        font-weight: 300;
        font-size: ${rem('16px')};
        color: ${theme.colors.primary}
        text-align: ${mediumDown && variant !== 'drawer' ? 'left' : 'center'};
      }
    `
  }}
`

export const Styles = () => {
  const theme = useContext(ThemeContext);
  const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
  const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
  return {
    Container: {
      maxWidth: rem(1440),
      position: 'relative',
      margin: `${rem('0px')} auto`,
    },
    ColInner: (startAdornment, hideDismissButton, variant) => {
      return {
        paddingTop: rem(14),
        paddingRight: rem(20),
        paddingBottom: rem(14),
        paddingLeft: rem(16),
        // ...(mediumUp && {
        //   padding: rem(14)
        // }),
        // right padding for dismiss button
        ...(!hideDismissButton && {
          paddingRight: rem(16)
        }),
        // left padding for start adornment mobile
        ...((startAdornment && !mediumUp) && {
          paddingLeft: rem(40),
          paddingRight: rem(32),
        }),
        // reset left padding for start adornment desktop (styled components bug?)
        ...((startAdornment && mediumUp) && {
          paddingLeft: rem(14),
          paddingRight: rem(24)
        }),
        ...((variant === 'drawer') && {
          paddingLeft: 0,
          paddingRight: 0
        })
      }
    },
    ColDrawer: (startAdornment, hideDismissButton) => {
      // console.log('variant', ...colInnerVariant)
      return {
        paddingTop: rem(0),
        paddingRight: rem(16),
        paddingBottom: rem(14),
        paddingLeft: rem(16),
        maxWidth: rem(800),
        margin: `0 auto`,
        // ...(mediumUp && {
        //   padding: rem(14)
        // }),
        // right padding for dismiss button
        ...(!hideDismissButton && {
          paddingRight: rem(20)
        }),
        // left padding for start adornment mobile
        ...((startAdornment && !mediumUp) && {
          paddingLeft: rem(40)
        }),
        // reset left padding for start adornment desktop (styled components bug?)
        ...((startAdornment && mediumUp) && {
          paddingLeft: rem(34)
        }),
      }
    },
    CtaButton: (variant) => {
      return {
        // height: rem(30),
        minWidth: rem(10),
        minHeight: rem(44),
        marginLeft: rem(30),
        marginTop: 0,
        padding: `${rem('6px')} ${rem('10px')}`,
        fontSize: rem(16),
        lineHeight: rem(24),
        background: 'transparent',
        // mobile styles // TODO: reverse this to desktop up
        ...(!mediumUp && {
          marginLeft: 0,
          marginTop: rem(16),
          minHeight: rem(32),
          fontSize: rem(14),
          lineHeight: rem(20),
        }),
        // cta-button variant mobile
        ...((variant === 'cta-button' && !mediumUp) && {
          marginRight: rem(8),
        }),
        // drawer
        ...(variant === 'quarternary' && {
          marginLeft: 0,
          marginTop: 0,
          border: 'none'
        }),
        // drawer mobile
        ...((variant === 'quarternary' && !mediumUp) && {
          fontSize: rem(14),
        lineHeight: rem(16),
        }),
      }
    }
  };
};
